var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_insta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Winds-Webapp",
    transform: "translate(-460.000000, -8608.000000)",
    fill: "#ADADB2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(0.000000, 8145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(252.000000, 463.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.863636,0 C211.975,0 208,3.975 208,8.86363636 L208,21.1363636 C208,26.025 211.975,30 216.863636,30 L229.136364,30 C234.025,30 238,26.025 238,21.1363636 L238,8.86363636 C238,3.975 234.025,0 229.136364,0 L216.863636,0 Z M231.181818,5.45454545 C231.931818,5.45454545 232.545455,6.06818182 232.545455,6.81818182 C232.545455,7.56818182 231.931818,8.18181818 231.181818,8.18181818 C230.431818,8.18181818 229.818182,7.56818182 229.818182,6.81818182 C229.818182,6.06818182 230.431818,5.45454545 231.181818,5.45454545 Z M223,7.5 C227.138636,7.5 230.5,10.8613636 230.5,15 C230.5,19.1386364 227.138636,22.5 223,22.5 C218.861364,22.5 215.5,19.1386364 215.5,15 C215.5,10.8613636 218.861364,7.5 223,7.5 Z M223,8.86363636 C219.618182,8.86363636 216.863636,11.6181818 216.863636,15 C216.863636,18.3818182 219.618182,21.1363636 223,21.1363636 C226.381818,21.1363636 229.136364,18.3818182 229.136364,15 C229.136364,11.6181818 226.381818,8.86363636 223,8.86363636 Z",
    id: "ic_insta"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInsta);
export default __webpack_public_path__ + "static/media/ic_insta.5ff62eda53adc02af063eccecf45dc72.svg";
export { ForwardRef as ReactComponent };